import React, { useState, useEffect, useContext } from 'react';
import SimpleTable from '../../components/tables/simpleTable';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import SearchFilter from '../../components/filters/search';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Loader from '../../components/loader/loader';
import { Col, Form, Row } from 'react-bootstrap';
import { DataContext } from '../../init/getData';
import { Modal, Button, Tree } from 'antd';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { isAuxFormatter, natureFormatter } from '../../components/formatters/defFormatter';
import { DownOutlined } from '@ant-design/icons';
import { FaLanguage } from 'react-icons/fa';
import { selectStyles } from '../../components/dropDown/selectStyle';







function ChartTree(props) {

  let { } = props;


  const { userData, settingData, serverApi, api, companyId, yearId, refData, treeData, secondaryCurrency, mainCurrency } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [language, setLanguage] = useState({ value: 'english', label: 'english' });

  const [filter, setFilter] = useState({ search: '', companyId, yearId, currency: 'main', fromDate: today, toDate: today, parentId: null });

  const table = 'chart';
  const title = 'Account';


  const languageOptions = [
    { value: 'english', label: 'english' },
    { value: 'arabic', label: 'arabic' },
    { value: 'french', label: 'french' },
  ]

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['chartTree']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  function buildTree(data) {
    const tree = [];
    const map = new Map();

    // Create a map of all items by id
    data?.forEach((item) => {
      map.set(item.id, {
        ...item,
        title: (
          <span style={{ color: item.isAux ? 'green' : 'inherit' }}>
            <strong>{item.accountId}</strong>{'. ' + item[language.value]}
          </span>
        ),
        key: item.id.toString(),
        children: []
      });
    });

    // Populate the tree structure
    data?.forEach((item) => {
      if (item.parentId === null) {
        tree.push(map.get(item.id));
      } else if (map.has(item.parentId)) {
        map.get(item.parentId).children.push(map.get(item.id));
      }
    });

    return tree;
  }

  const chartTreeData = buildTree(treeData);

  const onSelect = (selectedKeys, info) => {
  
  };



  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-1 mb-3'>
            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={languageOptions}
                isSearchable={true}
                placeholder="Select"
                onChange={setLanguage}
                value={language}
              />
            </Col>

            <Col md={6}>
            <Col md={1}>
            </Col>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button >
                <FiPrinter size={18} />
              </Button>
              <Button >
                <FiRotateCcw size={18} />
              </Button>
            </Col>
          </Row>


          <Row className='g-0 mb-3'>
            <Tree
              showLine
              switcherIcon={<DownOutlined />}
              defaultExpandedKeys={['0-0-0']}
              onSelect={onSelect}
              treeData={chartTreeData}
            />
          </Row>

        </>
      }

    </div>
  )
}

export default ChartTree;
